/**
 * The absolute base every API call is prefixed with. Empty in dev and in tests, so paths stay
 * relative and the Vite proxy forwards them; set to the Frappe origin (e.g.
 * `https://rfqdev.etoserp.com`) in a production build, where there is no proxy and the browser
 * talks to Frappe cross-origin. Configured ONLY through `VITE_BOSUN_API_BASE` — never hardcoded —
 * so switching backends is a one-value build change (design §1, §3).
 *
 * Trailing slashes are trimmed here so callers can concatenate `apiBase() + '/api/method/…'`
 * without producing a doubled slash.
 */
export function apiBase(): string {
  const raw = import.meta.env.VITE_BOSUN_API_BASE
  if (typeof raw !== 'string') return ''
  return raw.trim().replace(/\/+$/, '')
}
